import { collection, addDoc, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { isEduEmail } from './berkeleyEmailAccess';

export const EDU_VERIFY_RESEND_COOLDOWN_MS = 60 * 1000;

export function firestoreTimestampToMs(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') {
    return value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
  }
  if (value instanceof Date) return value.getTime();
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function eduVerifyResendRemainingSeconds(lastSentMs, now = Date.now()) {
  if (!lastSentMs) return 0;
  return Math.max(0, Math.ceil((lastSentMs + EDU_VERIFY_RESEND_COOLDOWN_MS - now) / 1000));
}

/**
 * Creates a `berkeleyVerifications` row (Cloud Function emails the .edu inbox)
 * and stores the address on the user doc.
 */
export async function submitEduEmailForVerification({
  uid,
  accountEmail,
  berkeleyEmail,
  source,
}) {
  const email = String(berkeleyEmail || '').trim().toLowerCase();
  if (!uid) throw new Error('Please sign in first.');
  if (!email) throw new Error('Please enter your .edu email.');
  if (!isEduEmail(email)) throw new Error('Email must be a .edu address.');

  await addDoc(collection(db, 'berkeleyVerifications'), {
    userId: uid,
    accountEmail: accountEmail || null,
    berkeleyEmail: email,
    status: 'pending',
    submittedAt: serverTimestamp(),
    ...(source ? { source } : {}),
  });
  await updateDoc(doc(db, 'users', uid), {
    berkeleyEmail: email,
    berkeleyEmailVerified: false,
  });
  return email;
}
